import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { Layout } from "@pionex-web-kit/components";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function BasicLayout(props) {
  return /*#__PURE__*/_jsx(Layout, _objectSpread({}, props));
}